import { render, staticRenderFns } from "./VerticalHistogram.vue?vue&type=template&id=ed2b9272&scoped=true"
import script from "./VerticalHistogram.vue?vue&type=script&lang=js"
export * from "./VerticalHistogram.vue?vue&type=script&lang=js"
import style0 from "./VerticalHistogram.vue?vue&type=style&index=0&id=ed2b9272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b9272",
  null
  
)

export default component.exports